import { MutationTree, GetterTree } from 'vuex'
import { RootState } from '..'
import { SET_HISTORY_COUNT } from '../types'

export interface NavigationState {
  historyCount: number;
}

const state: NavigationState = {
  historyCount: 0,
}

const getters: GetterTree<NavigationState, RootState> = {
  originalHistoryCount: (state) => state.historyCount,
}

const mutations: MutationTree<NavigationState> = {
  [SET_HISTORY_COUNT](state, count) {
    state.historyCount = count
  },
}

export default {
  state,
  getters,
  mutations,
}
